import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'white';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#0A5E5C] text-white hover:bg-[#084a49] focus-visible:ring-[#0A5E5C]',
    secondary: 'bg-[#D4A843] text-white hover:bg-[#b88f32] focus-visible:ring-[#D4A843]',
    outline: 'border-2 border-[#D4A843] text-[#D4A843] hover:bg-[#D4A843] hover:text-white focus-visible:ring-[#D4A843]',
    white: 'bg-white text-[#0A5E5C] hover:bg-gray-100 focus-visible:ring-white'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button className={twMerge(baseStyles, variants[variant], sizes[size], fullWidth && 'w-full', className)} {...props} data-id="element-224">
      {children}
    </button>;
}